import { render, staticRenderFns } from "./GoogleAuthorize.vue?vue&type=template&id=71fdb9e3&scoped=true&"
import script from "./GoogleAuthorize.vue?vue&type=script&lang=js&"
export * from "./GoogleAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./GoogleAuthorize.vue?vue&type=style&index=0&id=71fdb9e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fdb9e3",
  null
  
)

export default component.exports